import { ActionTree } from 'vuex';
import { DirectDebitState } from './types';
import { i18nGlobal } from '@/i18n';
import { Logger } from 'fsts';
import moduleUtils from '../moduleUtils';
import { RootState } from '../../types';
import { defaultBackendDirectDebit } from '@/shared/backend/directDebit';
import { DirectDebit } from '@/shared/model/directDebit';
import DownloadUtils from '@/shared/utils/downloadUtils';
import { CreditTransfer } from '@/shared/model/creditTransfer';

const logger = new Logger('actions');
export const actions: ActionTree<DirectDebitState, RootState> = {
  async createPreview({ commit }, files: File[]) {
    const data = new FormData();
    files.forEach((file) => {
      data.append('Files', file, file.name);
    });
    const lang = i18nGlobal.locale.value;

    return defaultBackendDirectDebit
      .createPreview(data, lang)
      .then((resp) => {
        commit('setDirectDebit', resp.data);
        return resp.data;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      });
  },
  async createPreviewForTrainers({ commit }, files: File[]) {
    const data = new FormData();
    files.forEach((file) => {
      data.append('Files', file, file.name);
    });
    const lang = i18nGlobal.locale.value;

    return defaultBackendDirectDebit
      .createPreviewForTrainers(data, lang)
      .then((resp) => {
        commit('setCreditTransferForTrainers', resp.data);
        return resp.data;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      });
  },
  createSEPAFiles({}, directDebitData: DirectDebit) {
    const lang = i18nGlobal.locale.value;
    return defaultBackendDirectDebit
      .createSEPAFiles(directDebitData, lang)
      .then(DownloadUtils.openDownloadedFileInBrowser);
  },
  createSEPAFilesForTrainers({}, creditTransferData: CreditTransfer) {
    const lang = i18nGlobal.locale.value;
    return defaultBackendDirectDebit
      .createSEPAFilesForTrainers(creditTransferData, lang)
      .then(DownloadUtils.openDownloadedFileInBrowser);
  },
};
